<template>
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 4h-17C2.7 4 2 4.7 2 5.5v13c0 .8.7 1.5 1.5 1.5h17c.8 0 1.5-.7 1.5-1.5v-13c0-.8-.7-1.5-1.5-1.5Zm-17 1h17c.3 0 .5.2.5.5V8H3V5.5c0-.3.2-.5.5-.5Zm17 14h-17c-.3 0-.5-.2-.5-.5V9h18v9.5c0 .3-.2.5-.5.5Z" /><circle cx="4.8" cy="6.47" r=".91" /><circle cx="7.47" cy="6.47" r=".91" /><circle cx="10.15" cy="6.47" r=".91" /></svg>
</template>

